export default __webpack_public_path__ + "static/media/bandeira_amarela.f0bd551a.svg";